import React from 'react'
import { ReportsProvider } from './Context'
import { Layout } from './layout'

export const ReportsPage = () => {
  return (
    <ReportsProvider>
      <Layout />
    </ReportsProvider>
  )
}
